import * as actionTypes from "../actions/actionTypes.js";

const initialState = {
    languageItemIstatisticsList:[]

};



export default function languageItemIstatistics(state = initialState, action) {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case actionTypes.GET_LANGUAGE_ITEM_ISTATISTICS_SECCUSS :
            return Object.assign({}, state, {languageItemIstatisticsList: action.payload});
        default:
            return state;
    }
}
